// https://github.com/typekit/webfontloader config
export default {
  custom: {
    families: ['proxima-nova'],
    urls: ['/fonts/fonts.css'],
  },
};
